import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import banner5 from "../assets/banner1.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaCheckCircle,
  FaUsers,
  FaStar
} from "react-icons/fa";

export default function HomeBanner3() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
    AOS.init({ duration: 1000, easing: "ease-in-out", once: true });
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  const sections = [
    {
      title: "Core Values",
      icon: <FaStar />,
      items: [
        "Safety",
        "Integrity",
        "Respect",
        "Teamwork",
        "Accountability & Transparency",
        "Leadership & Loyalty",
        "Honesty, Trust & Ingenuity",
        "Gender Equality",
        "Diversity & Inclusion"
      ]
    },
    {
      title: "Target Market",
      icon: <FaUsers />,
      items: [
        "Homeowners",
        "Contractors & Interior Designers",
        "DIY Enthusiasts",
        "Restaurants, Bars & Hotels",
        "Hospitals, Commercial Facilities",
        "Property Developers"
      ]
    },
    {
      title: "Why Choose Us",
      icon: <FaCheckCircle />,
      items: [
        "Premium-quality materials and expert craftsmanship",
        "Exceptional customer service from concept to delivery",
        "Sustainable and responsible production practices",
        "Flexible customization for residential and commercial projects",
        "Reliable experience delivering functional and stylish spaces"
      ]
    }
  ];

  return (
    <section
      className="MainBodySection"
      style={{
        padding: "110px 0",
        backgroundImage: `url(${banner5})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        color: "#fff"
      }}
    >
      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,0.6)"
        }}
      />

      <div className="container position-relative">
        {/* Section Header */}
        <div className="row justify-content-center mb-5 text-center">
          <div className="col-lg-9">
            <h2
              className="font-bold text-primary mb-3"
              data-aos="fade-down"
              style={{ fontSize: "2.6rem" }}
            >
             Kitchen Kings TZ
            </h2>
            <p
              data-aos="fade-up"
              style={{
                maxWidth: "760px",
                margin: "0 auto",
                lineHeight: 1.8,
                opacity: 0.9
              }}
            >
              We deliver functional, durable, and stylish furnishing solutions
              guided by strong values, a clear market focus, and a commitment to excellence.
            </p>
          </div>
        </div>

        {/* Cards */}
        <div className="row g-5 justify-content-center">
          {sections.map((section, idx) => (
            <div
              key={idx}
              className="col-md-4"
              data-aos="fade-up"
              data-aos-delay={idx * 200}
            >
              <div
                style={{
                  background: "rgba(255,255,255,0.1)",
                  backdropFilter: "blur(12px)",
                  borderRadius: "22px",
                  padding: "35px 30px",
                  height: "100%",
                  boxShadow: "0 12px 35px rgba(0,0,0,0.35)",
                  transition: "all 0.35s ease"
                }}
              >
                {/* Card Header */}
                <div className="d-flex align-items-center mb-4 gap-3">
                  <div
                    style={{
                      width: 46,
                      height: 46,
                      borderRadius: "50%",
                      background: "#00356d",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1.2rem"
                    }}
                  >
                    {section.icon}
                  </div>
                  <h5 className="font-bold mb-0">{section.title}</h5>
                </div>

                {/* Icon List */}
                <ul className="list-unstyled m-0">
                  {section.items.map((item, i) => (
                    <li
                      key={i}
                      className="d-flex align-items-start gap-3 mb-3"
                      style={{ lineHeight: 1.6, fontSize: "0.95rem" }}
                    >
                      <span
                        style={{
                          color: "#0d6efd",
                          marginTop: "4px",
                          fontSize: "0.85rem"
                        }}
                      >
                        <FaCheckCircle />
                      </span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
